import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d890c13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "image-ok" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text1" }, "项目申报、提交成功", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "项目已提交至后台审核，请耐心等待审核结果", -1))
const _hoisted_5 = { class: "button-ok" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭")

import wx from 'weixin-js-sdk'

// 当点击返回键时，不返回到上一页，而是直接关闭微信浏览器

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const wxback = () => {
  console.log('=======>', wx)
  setTimeout(() => {
    //需要jssdk
    wx.closeWindow()
  }, 800)
}

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "100",
        height: "100",
        src: require('@/assets/project/submission.png')
      }, null, 8, ["src"])
    ]),
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_van_button, {
        plain: "",
        round: "",
        size: "normal",
        type: "default",
        onClick: wxback
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}
}

})